import { render } from "./Channel.vue?vue&type=template&id=5e7f266d"
import script from "./Channel.vue?vue&type=script&lang=js"
export * from "./Channel.vue?vue&type=script&lang=js"
script.render = render

export default script